import { AxiosPromise, AxiosStatic } from "axios";
import { Address } from "../types/Address";
import {
  GooglePlacesAutocompleteItem,
  GooglePlacesAutocompleteRequestDto,
  GooglePlacesReverseGeocodeRequestDto,
} from "../types/GooglePlaces";

export const postGooglePlacesAutocomplete =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (
    data: GooglePlacesAutocompleteRequestDto
  ): AxiosPromise<GooglePlacesAutocompleteItem[]> =>
    await appAxios.post(`${serverURL}/google-places/autocomplete`, data, {
      withCredentials: true,
    });

export const getGooglePlacesDetails =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (placeId: string): AxiosPromise<Address> =>
    await appAxios.get(`${serverURL}/google-places/details/${placeId}`, {
      withCredentials: true,
    });

export const postGooglePlacesReverseGeocode =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (data: GooglePlacesReverseGeocodeRequestDto): AxiosPromise<Address> =>
    await appAxios.post(`${serverURL}/google-places/reverse-geocode`, data, {
      withCredentials: true,
    });
